'use client';

import { FC } from 'react';

import DownloadIcon from '@/public/icons/download.svg';
import EditIcon from '@/public/icons/edit.svg';
import AnimateIcon from '@/public/icons/play_circle.svg';

interface ActionButtonsProps {
  isVideo: boolean;
  onAnimate: () => void;
  onDownload: () => void;
  onEdit: () => void;
  animateText: string;
  downloadText: string;
  editText: string;
}

const STYLES = {
  button:
    'flex items-center justify-center relative bg-fill-zinc800 w-full h-12 rounded-md text-center text-base font-semibold',
  buttonGroup: 'flex gap-2 mb-2',
  icon: 'w-6 h-6 absolute top-3 left-3',
} as const;

export const ActionButtons: FC<ActionButtonsProps> = ({
  isVideo,
  onAnimate,
  onDownload,
  onEdit,
  animateText,
  downloadText,
  editText,
}) => (
  <div>
    <div className={STYLES.buttonGroup}>
      {!isVideo && (
        <button className={STYLES.button} onClick={onAnimate}>
          <AnimateIcon className={STYLES.icon} />
          {animateText}
        </button>
      )}
      <button className={STYLES.button} onClick={onDownload}>
        <DownloadIcon className={STYLES.icon} />
        {downloadText}
      </button>
    </div>

    {!isVideo && (
      <button className={STYLES.button} onClick={onEdit}>
        <EditIcon className={STYLES.icon} />
        {editText}
      </button>
    )}
  </div>
);
